// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DxpDw","type":"styles_type__1ugYu","choices":"styles_choices__2hLVv"};